import type { Lens } from '@dhmk/zustand-lens';

import type { Cart } from '@/clients/storefront/storefrontClient';

export enum CartActions {
  ADD_ITEM = 'addItem',
  REMOVE_ITEM = 'removeItem',
  VIEW_CART = 'viewCart',
  UPDATE_QTY = 'updateQty',
}

export type SunrunShopState = {
  cartId: string | null;
  cart: Cart | null;
  isCartOpen: boolean;
  cartAction: CartActions;
  selectedQuantity: number;
};

export type SunrunShopActions = {
  setCartId: (id: string | null) => void;
  setCart: (cart: Cart | null) => void;
  setIsCartOpen: (isCartOpen: boolean) => void;
  setCartAction: (action: CartActions) => void;
};

export type SunrunShopSlice = SunrunShopState & { actions: SunrunShopActions };

const sliceName = 'sunrunShop';
export const createSunrunShopSlice: Lens<SunrunShopSlice> = (set) => ({
  cartId: null,
  cart: null,
  isCartOpen: false,
  selectedQuantity: 1,
  cartAction: CartActions.VIEW_CART,
  actions: {
    setCartId: (cartId) => set({ cartId }, undefined, `${sliceName}/setCartId`),
    setCart: (cart) => set({ cart }, undefined, `${sliceName}/setCart`),
    setIsCartOpen: (isCartOpen) =>
      set({ isCartOpen }, undefined, `${sliceName}/setIsCartOpen`),
    setCartAction: (cartAction) =>
      set({ cartAction }, undefined, `${sliceName}/setCartAction`),
  },
});
